import { render, staticRenderFns } from "./SelectedProduct.vue?vue&type=template&id=620a9d18&scoped=true&"
import script from "./SelectedProduct.vue?vue&type=script&lang=js&"
export * from "./SelectedProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProduct.vue?vue&type=style&index=0&id=620a9d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a9d18",
  null
  
)

export default component.exports